module.exports = __webpack_public_path__ + "img/ic-payoneer-2.6c582c1d.svg";